'use strict';
const ping = require('./connect-header');
const searchFess = require('./search-fess');
const navigationListeners = require('./navigation-listeners');
const updateUsername = require('./navigation-update-username');

window.commonHeader = {};

/**
 *
 * Link building module.
 *
 * Loops through the data set,
 * builds out the markup elements
 * and calls itself if additional iteration is needed,
 * otherwise set the anchor link.
 *
 * @param data
 * @param user - data of the user passed in, should contain user.type and user.username at least
 * @param subMenu - true if we are building a submenu
 * @returns {HTMLUListElement}
 */
const builder = (data, user, subMenu) => {
	// Create order list element
	const ul = document.createElement('ul');

	// Scope variables
	let li,
		a,
		links,
		label,
		str,
		i,
		input;

	Object.values(data)
		.forEach(value => {
			if (typeof value.userType !== 'undefined' && user.type !== value.userType && user.type !== 'admin') {
				// Skip nav element if user.userType does not match this specific userType of the current nav element
				return;
			}

			if (typeof value.requiresProduct !== 'undefined' && !user[value.requiresProduct]) {
				// Skip nav element if the user is not entitled to the product it requires.
				// NOTE: intentionally applies to admins too — an account admin's header must
				// match what their teachers/students actually get (DH-358).
				return;
			}

			if (typeof user.analyticsUrl === 'undefined' && typeof value.analyticsUrl !== 'undefined') {
				// Skip analyticsUrl if no url is provided in the user data passed in
				return;
			}

			// Create list elements
			li = document.createElement('li');

			str = value.label;
			// Create anchor element
			a = document.createElement('a');

			// Label anchor element
			a.innerHTML = value.label;

			// Create label element
			label = document.createElement('label');

			// Label element
			label.innerHTML = str;

			if (typeof value.sub_links !== 'undefined') {
				i = document.createElement('i');
				i.setAttribute('class', 'fas fa-chevron-down');
				i.setAttribute('aria-hidden', 'true');
				label.appendChild(i);
			}

			// Mutate string. Replace space with dash
			str = 'drop-' +  str.replace(/\s+/g, '-').toLowerCase();

			// Create input element
			input = document.createElement('input');

			// Assign input type
			input.setAttribute('type', 'checkbox');

			// ID Input element
			input.setAttribute('id', str);

			// Assign class to label element
			label.setAttribute('class', 'toggle');

			// Assign label
			label.setAttribute('for', str);

			if (value.sub_links) {
				// Assign link value
				a.setAttribute('href', '#');

				// Create sub-link element
				links = builder(value.sub_links, user, true);

				// Set elements to list element
				li.appendChild(label);
				li.appendChild(a);
				li.appendChild(input);
				li.appendChild(links);
			} else {
				// Assign link value
				if (value.analyticsUrl && typeof user.analyticsUrl !== 'undefined') {
					// analytics url is based on the user data passed;
					a.setAttribute('href', user.analyticsUrl);
				} else {
					// normal link assignment
					a.setAttribute('href', value.link);
				}

				// Set elements to list element
				li.appendChild(a);
			}

			// Set list element to order list element
			if (value.hideOnSchools !== true) {
				ul.appendChild(li);
			}
		});

	if (!subMenu) {
		// Assign order list a class
		ul.setAttribute('class', 'menu');
	}

	// Order list element
	return ul;
};

const init = (user, jsonFileOverride) => {
	let menu = document.querySelector('.menu');
	let jsonFile = typeof jsonFileOverride !== 'undefined' && jsonFileOverride ?
		jsonFileOverride :
		'./Ajax/navigation.json';

	if (menu) {
		ping.Connect
			.getAjaxCall(jsonFile)
			.then(response => {
				menu.replaceWith(builder(response.navigation, user, false));

				searchFess.init();

				if (typeof user.firstName !== 'undefined') {
					updateUsername.init(user.firstName);
				}

				navigationListeners.init();
			})
			.catch(error => error);
	}
};

/* Allow the re-render of the header globally */
window.commonHeader.reinit = function(user, jsonFileOverride) {
	let menuWrap = document.querySelector('.menu-wrapper');

	if (menuWrap) {
		init(user, jsonFileOverride);
	}
};

module.exports =  {
	init: init
};
